import React from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';

const RenderLoader = (props) =>
  <Dimmer active={props.isloading} inverted>
    <Loader inverted size={props.size} />
  </Dimmer>
export default RenderLoader;
